module.exports = "/images/shutterstock_555325381 1.png?35e48d924f65f448489fbd28090d9fe3";